import { styled } from 'theme'

export const StyledUserList = styled.div``
export const MenuTitle = styled.span`
  margin-right: 8px;
  font-weight: bold;
`
